/* eslint-disable no-bitwise */
/* SHA-256, only for the ads rollout bucket (ads spec 3.2). Synchronous (not
   crypto.subtle) so the first feed already knows its ads. The app
   (pres-mobile app/utils/sha256.ts) and the backend use the same formula:
   first 4 bytes of SHA-256(installId), big-endian, mod 100. */

const primes = (count) => {
  const out = []
  for (let n = 2; out.length < count; n++) {
    if (out.every((p) => n % p !== 0)) out.push(n)
  }
  return out
}
const frac = (x) => ((x - Math.floor(x)) * 0x100000000) >>> 0
const P = primes(64)
const K = P.map((p) => frac(Math.cbrt(p)))
const H0 = P.slice(0, 8).map((p) => frac(Math.sqrt(p)))

const utf8 = (text) => {
  const bytes = []
  for (const ch of text) {
    const c = ch.codePointAt(0)
    if (c < 0x80) bytes.push(c)
    else if (c < 0x800) bytes.push(0xc0 | (c >> 6), 0x80 | (c & 63))
    else if (c < 0x10000) bytes.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 63), 0x80 | (c & 63))
    else
      bytes.push(0xf0 | (c >> 18), 0x80 | ((c >> 12) & 63), 0x80 | ((c >> 6) & 63), 0x80 | (c & 63))
  }
  return bytes
}

export function sha256(text) {
  const bytes = utf8(text)
  const bitLength = bytes.length * 8
  bytes.push(0x80)
  while (bytes.length % 64 !== 56) bytes.push(0)
  for (let i = 7; i >= 0; i--) bytes.push(i > 3 ? 0 : (bitLength >>> (i * 8)) & 0xff)

  const h = H0.slice()
  const w = new Array(64)
  const rotr = (x, n) => (x >>> n) | (x << (32 - n))
  for (let chunk = 0; chunk < bytes.length; chunk += 64) {
    for (let i = 0; i < 16; i++) {
      const j = chunk + i * 4
      w[i] = ((bytes[j] << 24) | (bytes[j + 1] << 16) | (bytes[j + 2] << 8) | bytes[j + 3]) >>> 0
    }
    for (let i = 16; i < 64; i++) {
      const s0 = rotr(w[i - 15], 7) ^ rotr(w[i - 15], 18) ^ (w[i - 15] >>> 3)
      const s1 = rotr(w[i - 2], 17) ^ rotr(w[i - 2], 19) ^ (w[i - 2] >>> 10)
      w[i] = (w[i - 16] + s0 + w[i - 7] + s1) >>> 0
    }
    let [a, b, c, d, e, f, g, hh] = h
    for (let i = 0; i < 64; i++) {
      const t1 =
        (hh + (rotr(e, 6) ^ rotr(e, 11) ^ rotr(e, 25)) + ((e & f) ^ (~e & g)) + K[i] + w[i]) >>> 0
      const t2 = ((rotr(a, 2) ^ rotr(a, 13) ^ rotr(a, 22)) + ((a & b) ^ (a & c) ^ (b & c))) >>> 0
      hh = g
      g = f
      f = e
      e = (d + t1) >>> 0
      d = c
      c = b
      b = a
      a = (t1 + t2) >>> 0
    }
    ;[a, b, c, d, e, f, g, hh].forEach((v, i) => (h[i] = (h[i] + v) >>> 0))
  }
  const out = []
  h.forEach((v) => out.push(v >>> 24, (v >>> 16) & 0xff, (v >>> 8) & 0xff, v & 0xff))
  return out
}

// 0..99; the same install stays in the same group as rolloutPercent grows.
export function rolloutBucket(installId) {
  const [b0, b1, b2, b3] = sha256(installId.toLowerCase())
  return (((b0 << 24) | (b1 << 16) | (b2 << 8) | b3) >>> 0) % 100
}
